import React, { Component } from 'react';
import { Form, Input, Divider, Radio } from 'antd';
import { language } from '../../../language';
import { assign } from 'lodash';
import {
    ColorPicker,
    LinkType,
    NumberInput,
    FormItemLayout,
    ConfigFormDecorator,
} from '../../tools';
import './index.less';

const FormItem = Form.Item;
const RadioGroup = Radio.Group;

/**
 * 文本组件-配置表单
 */
class text extends Component<any> {
    changeLink = (newValue) => {
        const { value, onChange } = this.props;
        onChange(assign({}, value, newValue));
    };

    render() {
        const {
            form: { getFieldDecorator },
            value: { linkType, linkParams },
            linkTypes,
            linkTypeMode,
            selector,
        } = this.props;
        const formItemLayout = FormItemLayout;
        return (
            <div className="textBox">
                <Form className="text-form">
                    <Divider orientation="left">
                        {language.getText('components.Text.contentSet')}
                    </Divider>
                    <div className="divider-box">
                        <FormItem
                            {...formItemLayout}
                            label={language.getText('components.Text.content')}
                        >
                            {getFieldDecorator('content', {
                                rules: [
                                    {
                                        required: true,
                                        message: language.getText(
                                            'components.Text.contentRequired'
                                        ),
                                    },
                                ],
                            })(<Input.TextArea autoSize />)}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label={language.getText('components.Text.color')}
                        >
                            {getFieldDecorator('fontColor')(<ColorPicker />)}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label={language.getText('components.Text.size')}
                        >
                            {getFieldDecorator('fontSize')(<NumberInput min={10} />)}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label={language.getText('components.Text.textAlign')}
                        >
                            {getFieldDecorator('align')(
                                <RadioGroup className="align-style">
                                    <Radio value={'left'}>
                                        {language.getText('components.Text.left')}
                                    </Radio>
                                    <Radio value={'center'}>
                                        {language.getText('components.Text.center')}
                                    </Radio>
                                    <Radio value={'right'}>
                                        {language.getText('components.Text.right')}
                                    </Radio>
                                </RadioGroup>
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label={language.getText('components.ImageAd.pageMargin')}
                        >
                            {getFieldDecorator('margin')(<NumberInput min={0} />)}
                        </FormItem>
                    </div>
                    <Divider orientation="left">
                        {language.getText('components.Text.targetLink')}
                    </Divider>
                    <div className="divider-box">
                        <FormItem>
                            <LinkType
                                linkTypes={linkTypes}
                                linkTypeMode={linkTypeMode}
                                selector={selector}
                                value={{ linkType, linkParams }}
                                onChange={this.changeLink}
                            />
                        </FormItem>
                    </div>
                </Form>
            </div>
        );
    }
}

export const Text = ConfigFormDecorator(text);
